<div class="form-check">
  <input #input
    (blur)="onBlur()"
    [(ngModel)]="value"
    [attr.aria-label]="title"
    [attr.data-error-label]="errorLabel"
    [attr.data-error-message]="control?.errors?.message"
    [attr.data-has-error]="isInvalid"
    [ngClass]="{ 'ba-error': hasErrorAndTrackPiwik }"
    [required]="required"
    id="{{_id}}_input"
    name="{{name}}"
    title="{{title}}"
    type="checkbox"
    [disabled]="disabled">
  <label for="{{_id}}_input" id="{{_id}}_label">
    <ng-content></ng-content>
    @if (required) {
      <span>*</span>
    }
  </label>
  @if (hinweis) {
    <wba-fragezeichen
      label="{{title ? title : 'Auswahlbox'}}"
      [dataTarget]="hinweis?.target"
      [dataModal]="hinweis?.modal"
      id="{{_id}}_fragezeichen"
      smaller="true"/>
  }
</div>
